var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { Link as RouterLink } from 'react-router-dom';
import React from 'react';
import styled, { ThemeProvider } from 'styled-components';
import theme from './theme';
import getIcon from '../utils/getIcon';
export var baseLinkStyles = function (_a, linktype) {
    var component = _a.component;
    return "\n  cursor: pointer;\n  color: " + component.link[linktype].color + ";\n  text-decoration: " + component.link[linktype].textDecoration + ";\n\n  &:active,\n  &:hover {\n    outline-width: 0;\n    color: " + component.link[linktype].hover.color + ";\n    text-decoration: " + component.link[linktype].hover.textDecoration + ";\n  }\n";
};
var StyledLink = styled(RouterLink)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  ", "\n"], ["\n  ", ";\n  ",
    "\n"])), function (_a) {
    var compTheme = _a.theme, linktype = _a.linktype;
    return baseLinkStyles(compTheme, linktype);
}, function (_a) {
    var align = _a.align, component = _a.theme.component, linktype = _a.linktype;
    return linktype === 'icon' &&
        "svg:" + (align === 'right' ? 'last' : 'first') + "-child {\n      position: relative;\n      top: -0.15em;\n      margin-" + (align === 'right' ? 'left' : 'right') + ": " + component.link.icon.margin + ";\n      font-size: " + component.link.icon.fontSize + ";\n    }";
});
export var Link = function (_a) {
    var solo = _a.solo, icon = _a.icon, iconType = _a.iconType, iconAlignment = _a.iconAlignment, children = _a.children, renderAs = _a.renderAs, restProps = __rest(_a, ["solo", "icon", "iconType", "iconAlignment", "children", "renderAs"]);
    if (renderAs) {
        restProps.as = renderAs;
    }
    if (solo) {
        return (React.createElement(ThemeProvider, { theme: theme },
            React.createElement(React.Fragment, null,
                React.createElement(StyledLink, __assign({ linktype: "solo" }, restProps), children))));
    }
    if (!icon && !iconType) {
        return (React.createElement(ThemeProvider, { theme: theme },
            React.createElement(React.Fragment, null,
                React.createElement(StyledLink, __assign({ linktype: "base" }, restProps), children))));
    }
    var iconElement;
    if (icon) {
        iconElement = icon;
    }
    if (!iconElement && iconType) {
        var IconTag = getIcon(iconType);
        iconElement = React.createElement(IconTag, null);
    }
    return (React.createElement(ThemeProvider, { theme: theme },
        React.createElement(React.Fragment, null,
            React.createElement(StyledLink, __assign({ linktype: "icon" }, restProps, { align: iconAlignment }), iconAlignment !== 'right' ? (React.createElement(React.Fragment, null,
                iconElement,
                children)) : (React.createElement(React.Fragment, null,
                children,
                iconElement))))));
};
export var PhoneLink = function (_a) {
    var className = _a.className, phoneNumber = _a.phoneNumber;
    return (React.createElement(Link, { as: "a", className: className, to: "tel:" + phoneNumber }, phoneNumber));
};
export var EmailLink = function (_a) {
    var className = _a.className, mail = _a.mail;
    return (React.createElement(Link, { as: "a", className: className, to: "mailto:" + mail }, mail));
};
var templateObject_1;
//# sourceMappingURL=index.js.map